module.exports = __webpack_public_path__ + "img/Vector3.e82d83aa.svg";